import {
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'

type AccountMenuIdentityHeaderProps = {
  personName?: string
  email?: string
}

export function AccountMenuIdentityHeader({
  personName,
  email,
}: AccountMenuIdentityHeaderProps) {
  const trimmedName = personName?.trim() ?? ''
  const trimmedEmail = email?.trim() ?? ''

  if (!trimmedName && !trimmedEmail) return null

  return (
    <>
      {trimmedName ? (
        <DropdownMenuLabel className="truncate text-sm font-medium text-foreground">
          {trimmedName}
        </DropdownMenuLabel>
      ) : null}
      {trimmedEmail ? (
        <DropdownMenuLabel className="truncate text-xs font-normal text-muted-foreground">
          {trimmedEmail}
        </DropdownMenuLabel>
      ) : null}
      <DropdownMenuSeparator />
    </>
  )
}
